import $ from 'jquery';

$('.header__bars').on('click', function(event) {
    event.preventDefault();
    $(this).toggleClass('active');
    $('.header__nav ul').toggleClass('active')
});

$('.header__nav ul .close').on('click', () => {
    $('.header__nav ul, .header__bars').removeClass('active');
});

$(document).mouseup(function(e) {
    var button = $('.header__nav ul, .header__nav ul *, .header__bars, .header__bars *');
    if (!button.is(e.target)) {
        $('.header__nav ul').removeClass('active');
        $('.header__bars').removeClass('active')
    }
});

let opportunityBlock = $('#opportunity-block');
let surveyexamplesBlock = $('#surveyexamples-block')

function scrollToBlock(hash) {
    if (hash == '#opportunity') {
        $("html, body").animate({ scrollTop: opportunityBlock.offset().top }, 1000);
    }
    if (hash == '#surveyexamples') {
        $("html, body").animate({ scrollTop: surveyexamplesBlock.offset().top }, 1000);
    }
}

scrollToBlock(location.hash);

if (opportunityBlock && opportunityBlock.length > 0) {
    $('.opportunity-scroll').on('click', function(e) {
        e.preventDefault();
        scrollToBlock('#opportunity');
    })
}
